/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2023. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: HttpTokenProvider.ts
 * Created by: Kevin
 * Create Date: 2023-05-23 15:09
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

// import Log from "@/commons/logs/Log";
import HttpRequestConfig from "@/commons/https/HttpRequestConfig";
// import Result from "@/commons/Result";
// import AppConfig from "@/commons/AppConfig";
// import {StatusDef} from "@/commons/StatusDef";
// import HttpRequestGet from "@/commons/https/HttpRequestGet";
// import GatewayResolver from "@/commons/https/GatewayResolver";
// import HttpExecutor from "@/commons/https/HttpExecutor";
// import {HttpStatus} from "@/commons/https/HttpStatus";

export default class HttpTokenProvider {

    public static readonly None: HttpTokenProvider = new HttpTokenProvider('', '');

    public static readonly TeamService: HttpTokenProvider = new HttpTokenProvider('', '');

    public static set(config: HttpRequestConfig | null, token?: HttpTokenProvider | null) {
        if (config == null || token == null) {
            return;
        }

        config.tokenProvider = token;

        if (config.headers == null) {
            config.headers = {};
        }

        if (token.isAccessTokenPresent()) {
            config.headers['Access-Token'] = token.accessToken;
            // Log.debug(`Set access token: ${token.accessToken}`)
            // Log.debug(`Set refresh token: ${token.refreshToken}`)
        }

        return;
    }

    private _accessToken: string;
    private _refreshToken: string;

    public constructor(accessToken: string, refreshToken: string) {
        this._accessToken = accessToken;
        this._refreshToken = refreshToken;
    }

    public isAccessTokenPresent(): boolean {
        return this._accessToken != null && this._accessToken.length > 0;
    }

    public isRefreshTokenPresent(): boolean {
        return this._refreshToken != null && this._refreshToken.length > 0;
    }

    public set(accessToken: string, refreshToken: string) {
        this._accessToken = accessToken;
        this._refreshToken = refreshToken;
    }

    public reset() {
        this._accessToken = '';
        this._refreshToken = '';
    }

    public toString(): string {
        return `accessToken: ${this._accessToken}, refreshToken: ${this._refreshToken}`;
    }

    get accessToken(): string {
        return this._accessToken;
    }

    get refreshToken(): string {
        return this._refreshToken;
    }

    set accessToken(value: string) {
        this._accessToken = value;
    }

    set refreshToken(value: string) {
        this._refreshToken = value;
    }

}